import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import {
	AppBar, Avatar, Button, makeStyles, Toolbar,
} from '@material-ui/core';
import { PersonOutline } from '@material-ui/icons';
import useFirebase from '../hooks/firebase';

const useStyles = makeStyles(() => ({
	root: {},
}));

export default function AdminHeader(props) {
	const { className } = props;
	const classes = useStyles();

	const { signInGoogle, signOut, currentUser } = useFirebase();

	return (
		<>
			<AppBar className={clsx(classes.root, className)}>
				<Toolbar>
					<div style={{ flex: '100% 1 1' }} />
					{currentUser ? (
						<Button
							onClick={() => signOut()}
							endIcon={<Avatar src={currentUser.photoURL} />}
							variant="contained"
						>
							Sign&nbsp;Out
						</Button>
					) : (
						<Button
							style={{ height: 52 }}
							onClick={() => signInGoogle()}
							endIcon={<PersonOutline />}
							variant="contained"
						>
							Sign&nbsp;In
						</Button>
					)}
				</Toolbar>
			</AppBar>
			<Toolbar />
		</>
	);
}

AdminHeader.defaultProps = {
	className: undefined,
};

AdminHeader.propTypes = {
	className: propTypes.string,
};
